module.exports = __webpack_public_path__ + "img/instagram.618efc9.svg";